import { useId } from 'react';
import type { MetricInfo } from './metricInfo';
import styles from './InfoTip.module.css';

interface InfoTipProps {
    info: MetricInfo;
    label: string;
    /** Lado em que o balao cresce a partir do icone. Use "start" nos itens da borda esquerda. */
    align?: 'start' | 'end';
}

/** Icone (i) com o calculo e a leitura da metrica. Abre no hover e no foco do teclado. */
export function InfoTip({ info, label, align = 'end' }: InfoTipProps) {
    const id = useId();
    return (
        <span className={styles.wrapper}>
            <button type="button" className={styles.trigger} aria-label={`Como ler: ${label}`} aria-describedby={id}>
                i
            </button>
            <span
                id={id}
                role="tooltip"
                className={`${styles.tooltip} ${align === 'start' ? styles.alignStart : styles.alignEnd}`}
            >
                <span className={styles.term}>Cálculo.</span> {info.calculo}
                <span className={styles.reading}>
                    <span className={styles.term}>Leitura.</span> {info.leitura}
                </span>
            </span>
        </span>
    );
}
